import React from "react";

export const fmtUSD = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtCompact = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }); }
  catch { return iso; }
};
export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
  catch { return iso; }
};

export const PageHeader = ({ overline, title, subtitle, children }) => (
  <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
    <div>
      {overline && <div className="overline">{overline}</div>}
      <h1 className="font-serif-display text-4xl sm:text-5xl text-[#F6F0E6] mt-1 leading-[1.05]">{title}</h1>
      {subtitle && <p className="text-[#D9D9D9]/70 text-sm mt-2 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-3">{children}</div>}
  </header>
);

const STATUS_STYLES = {
  // Media
  published:        { bg: "bg-[#C9A44C]/15", border: "border-[#C9A44C]/40", text: "text-[#C9A44C]" },
  approved:         { bg: "bg-[#C9A44C]/10", border: "border-[#C9A44C]/30", text: "text-[#C9A44C]" },
  ready_for_review: { bg: "bg-[#F28C18]/12", border: "border-[#F28C18]/40", text: "text-[#F28C18]" },
  imported:         { bg: "bg-[#D9D9D9]/8",  border: "border-[#D9D9D9]/25", text: "text-[#D9D9D9]" },
  processing:       { bg: "bg-[#D9D9D9]/8",  border: "border-[#D9D9D9]/25", text: "text-[#D9D9D9]" },
  archived:         { bg: "bg-[#D9D9D9]/6",  border: "border-[#D9D9D9]/20", text: "text-[#D9D9D9]/70" },
  private:          { bg: "bg-[#D9D9D9]/6",  border: "border-[#D9D9D9]/20", text: "text-[#D9D9D9]/70" },
  error:            { bg: "bg-[#E8452C]/12", border: "border-[#E8452C]/40", text: "text-[#E8452C]" },
  // Donations
  confirmed:        { bg: "bg-[#C9A44C]/15", border: "border-[#C9A44C]/40", text: "text-[#C9A44C]" },
  pending:          { bg: "bg-[#F28C18]/12", border: "border-[#F28C18]/40", text: "text-[#F28C18]" },
  failed:           { bg: "bg-[#E8452C]/12", border: "border-[#E8452C]/40", text: "text-[#E8452C]" },
  refunded:         { bg: "bg-[#D9D9D9]/8",  border: "border-[#D9D9D9]/25", text: "text-[#D9D9D9]" },
  // Generic
  connected:        { bg: "bg-[#C9A44C]/15", border: "border-[#C9A44C]/40", text: "text-[#C9A44C]" },
  manual:           { bg: "bg-[#F28C18]/10", border: "border-[#F28C18]/30", text: "text-[#F28C18]" },
  not_configured:   { bg: "bg-[#E8452C]/8",  border: "border-[#E8452C]/30", text: "text-[#E8452C]" },
  ready:            { bg: "bg-[#C9A44C]/10", border: "border-[#C9A44C]/30", text: "text-[#C9A44C]" },
};

export const StatusBadge = ({ status, children }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.imported;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] tracking-[0.18em] uppercase border ${s.bg} ${s.border} ${s.text}`}>
      {children || (status || "—").replace(/_/g, " ")}
    </span>
  );
};

export const Empty = ({ title, subtitle, children }) => (
  <div className="bento-card !p-10 text-center">
    <span className="glow-blob" />
    <div className="font-serif-display text-2xl text-[#F6F0E6]">{title}</div>
    {subtitle && <p className="text-[#D9D9D9]/70 text-sm mt-2 max-w-md mx-auto">{subtitle}</p>}
    {children && <div className="mt-5">{children}</div>}
  </div>
);
